import axiosInstance from "../utils/axios";

export const governingMinistryService = {
  fetchAllWithoutPaginate: async () => {
    const response = await axiosInstance.get("/governing-ministry/all");
    return response.data;
  },
  fetchAll: async (params = {}) => {
    const response = await axiosInstance.get("/governing-ministry", { params });
    return response.data;
  },
  findById: async (id) => {
    const response = await axiosInstance.get(`/governing-ministry/${id}`);
    return response.data;
  },
  store: async (data) => {
    const response = await axiosInstance.post("/governing-ministry", data);
    return response.data;
  },
  update: async (id, data) => {
    const response = await axiosInstance.put(`/governing-ministry/${id}`, data);
    return response.data;
  },
  delete: async (id) => {
    const response = await axiosInstance.delete(`/governing-ministry/${id}`);
    return response.data;
  },
};
